module.exports = __webpack_public_path__ + "assets/img/1f1f07377ec8afe575a824126bd2507c.png";